import React, { Component } from 'react';
import { ButtonToolbar, Button, FormGroup, ControlLabel, FormControl, Checkbox, Grid, Row, Col, Modal } from 'react-bootstrap';
import Select from "react-select";
import DatePicker from 'react-16-bootstrap-date-picker';
import { PropTypes } from 'prop-types';
import { AddOnsBusSchedCommand } from '../../../addOns/commands/AddOnsCommand';
import { TmlBusSchedForm } from './TmlBusSchedForm';
import { TmlStopSchedForm } from './TmlStopSchedForm';
import { TmlUpdateSelectionForm } from './TmlUpdateSelectionForm';
import { TmlFilterConfigs } from './TmlFilterConfigs';
import { TmlExceptionConfigs } from './TmlExceptionConfigs'
import { TmlMissingConfigs } from './TmlMissingConfigs';
import { HandleMessage } from '../../../HandleMessage';
import { TitleRow } from '../../../TitleRow';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { SchedulesCommand } from '../../commands/SchedulesCommand';
import { DrawCommand } from '../../commands/DrawCommand';
import { ProviderSelectionsCommand } from '../../commands/ProviderSelectionsCommand';

export class TmlScheduleGenerator extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            dependencies: {
                selection: undefined,
                setOfDayTypes: [],
                schedules: []
            },
            form: {
                saveSelection: true,
                referenceDate: new Date().toISOString(),
                documentDate: new Date().toISOString(),
                frequency: "",
                hideLoopsChk: false,
                layout: 0,
                addOn: ""
            },
            commands: {
                selections: new ProviderSelectionsCommand(),
                setOfDayTypes: new SetOfDayTypesCommand(),
                schedules: new SchedulesCommand(),
                draw: new DrawCommand(),
                addOns: new AddOnsBusSchedCommand()
            },
            render: {
                layouts: [
                    { id: 0, label: "Linha", data: {} },
                    { id: 1, label: "Paragem", data: {} },
                ],
                stopSchedFilter: {
                    show: false,
                    parameters: undefined,
                    onCheckValue: undefined
                },
                filterConfigs: {
                    show: false,
                    lines: []
                },
                missingConfigs: {
                    show: false,
                    data: [],
                    filter: undefined
                },
                selectionsModal: {
                    show: false
                },
                exceptionConfigs: {
                    show: false,
                    lines: [],
                    linesToRemoveExceptions: []
                }
            },
            actions: {
                isLoadingEdition: true,
                isLoadingSelections: true,
                isLoadingSelectionData: false,
                isLoadingSetOfDayTypes: true,
                isLoadingSchedules: true,
                isLoadingBusSchedList: true,
                isLoadingAddOn: false,
                isCheckingConfigs: false,
                isGenerating: false,
                isUpdating: false,
                isSettingOrder: false,
                isExecutingAddOn: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            transient: {
                selection: {
                    id: 0,
                    layout: 0,
                    frequency: undefined,
                    referenceDate: undefined,
                    documentDate: undefined,
                    dataCode: undefined,
                    selections: []
                },
                dataSelection: undefined
            },
            addOns: []
        };
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);
        this.getSelections();
        this.getSetOfDayTypes();
        this.getAddOns();
        const edition = this.context.getOwnEdition();
        edition.addObserver(this);

        this.setState({
            edition: edition
        });
    }

    componentWillUnmount() {
        this.state.edition.removeObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = false;

        this.setState({
            actions: actions
        });
    }

    updatePlanning() {
        const { actions } = this.state;

        if (actions.isLoadingSelections) {
            // Wait for the selections to avoid conflicts between the get schedules request
            return;
        }

        actions.isLoadingSchedules = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.state;
            this.getSchedules(edition);
        });
    }

    // ----------------------

    getSelections() {
        const { actions, commands } = this.state;

        commands.selections.getTml(
            (a) => this.listSuccessCallback(a, "selection", "isLoadingSelections", () => this.finalizeGetSelectionsCallback()),
            (a) => this.listErrorCallback(a, "selection", "isLoadingSelections", null)
        );

        actions.isLoadingSelections = true;

        this.setState({
            actions: actions
        });
    }

    getSelectionData(type, code, callback) {
        const { dependencies } = this.state;

        if (undefined === dependencies.selection || null === dependencies.selection) {
            this.callCallback(callback);
            return;
        }

        if (undefined !== dependencies.selection.selections.find(data => data.type === type && data.dataCode === code)) {
            this.callCallback(callback);
            return;
        }

        const { actions, commands } = this.state;

        commands.selections.getTmlData(
            type,
            code,
            (a) => this.getTmlDataSuccessCallback(a, () => this.callCallback(callback)),
            (a) => this.getTmlDataErrorCallback(a, () => this.callCallback(callback))
        );

        actions.isLoadingSelectionData = true;

        this.setState({
            actions: actions
        });
    }

    getSetOfDayTypes() {
        const { actions, commands } = this.state;

        commands.setOfDayTypes.listFull(
            (a) => this.listSuccessCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes"),
            (a) => this.listErrorCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes")
        );

        actions.isLoadingSetOfDayTypes = true;

        this.setState({
            actions: actions
        });
    }

    getSchedules(edition) {
        const { actions, commands } = this.state;
        commands.schedules.list(
            edition.planning,
            (a) => this.listSuccessCallback(a, "schedules", "isLoadingSchedules"),
            (a) => this.listErrorCallback(a, "schedules", "isLoadingSchedules")
        );

        actions.isLoadingSchedules = true;

        this.setState({
            actions: actions
        });
    }

    getMissingConfigs(filter) {
        const { commands, actions } = this.state;

        actions.isCheckingConfigs = true;
        commands.draw.getMissingConfigsTml(
            filter,
            (a) => this.getMissingConfigsSuccessCallback(a, filter),
            (a) => this.getMissingConfigsErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    updateLineExceptions(lines) {
        const { commands, actions } = this.state;
        const LinesArray = [lines];
        const codes = LinesArray[0].lines.map(line => line.code);

        actions.isUpdating = true;
        commands.draw.updateLinesEx(
            codes,
            (a) => this.UpdateLinesExSuccessCallback(a),
            (a) => this.UpdateLinesExErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    // ----------------

    getAddOns() {
        const { commands, actions } = this.state;
        actions.isLoadingAddOns = true;
        commands.addOns.get(
            (a) => this.addOnsSuccessCallback(a),
            () => this.addOnsErrorCallback()
        );
    }

    addOnsSuccessCallback(result) {
        const { actions } = this.state;
        actions.isLoadingAddOns = false;

        this.setState({
            addOns: result,
            actions: actions
        });
    }

    addOnsErrorCallback() {
        const { actions } = this.state;

        actions.isLoadingAddOns = false;

        this.setState({
            actions: actions
        });
    }

    onExecuteUpdateSelection(addOn, label, parameters = undefined) {
        const { commands, actions } = this.state;

        actions.isExecutingAddOn = true;
        commands.addOns.execute(
            addOn,
            label,
            parameters,
            (a) => this.operationSuccessCallback(a, "isExecutingAddOn", false),
            (a) => this.operationErrorCallback(a, "isExecutingAddOn")
        );

        this.setState({
            actions: actions
        });
    }

    onContinueAddOn(addOn, label, parameters = undefined) {
        this.onExecuteUpdateSelection(addOn, label, parameters)
        this.onCancelUpdateSelection();
    }

    operationSuccessCallback(messageReceived, updateAction, callback = undefined) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof callback) {
            callback();
        }
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }


        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ----------------

    listSuccessCallback(result, dataType, action, callback = undefined) {
        const { dependencies, actions } = this.state;

        actions[action] = false;
        dependencies[dataType] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, action, value = []) {
        const { dependencies, actions, message } = this.state;

        actions[action] = false;
        dependencies[dataType] = value;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    UpdateLinesExSuccessCallback(result) {
        const { actions, dependencies } = this.state;

        dependencies.selection.linesToRemoveExceptions = result;

        actions.isUpdating = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: "Linhas atualizadas com sucesso!",
                style: "success",
                title: "Sucesso!",
                icon: "success"
            }
        });
    }

    UpdateLinesExErrorCallback(messageReceived) {
        const { actions, message } = this.state;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        actions.isUpdating = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    getMissingConfigsSuccessCallback(result, filter) {
        if (!Array.isArray(result)) {
            throw new Error("Ocorreu um erro a verificar as configurações");
        }

        const { actions } = this.state;

        actions.isCheckingConfigs = false;

        if (0 === result.length) {
            this.onRegenerate(filter);
        }
        else {
            const { render } = this.state;

            render.missingConfigs.show = true;
            render.missingConfigs.data = result;
            render.missingConfigs.filter = filter;

            this.setState({
                render: render
            });
        }

        this.setState({
            actions: actions
        });
    }

    getMissingConfigsErrorCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isCheckingConfigs = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    generationSuccessCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    generationErrorCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    getTmlDataSuccessCallback(data, callback) {
        const { dependencies, actions } = this.state;

        dependencies.selection.selections.push(data);
        actions.isLoadingSelectionData = false;

        this.setState({
            dependencies: dependencies,
            actions: actions
        });
        this.callCallback(callback);
    }

    getTmlDataErrorCallback(messageReceived, callback) {
        const { actions, message } = this.state;

        actions.isLoadingSelectionData = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
        this.callCallback(callback);
    }

    finalizeGetSelectionsCallback() {
        const { dependencies, form, transient, edition } = this.state;
        const { selection } = dependencies;

        if (undefined === selection || null === selection) {
            // Update Planning Edition stuffs with the current edition
            this.updatePlanning();
            return;
        }

        const selectionReferenceDate = new Date(selection.referenceDate);
        const selectionDocumentDate = new Date(selection.documentDate);

        form.layout = selection.layout;
        form.frequency = 0 >= selection.frequency ? "" : selection.frequency;
        form.referenceDate = 0 === selection.referenceDate ? new Date().toISOString() : selectionReferenceDate.toISOString();
        form.documentDate = 0 === selection.documentDate ? "" : selectionDocumentDate.toISOString();

        transient.selection.id = selection.id;
        transient.selection.selections = selection.selections.map(dataSelection => this.mapDataSelection(dataSelection));

        edition.update(selectionReferenceDate, undefined, false, true);
        this.setState({
            form: form,
            transient: transient
        }, () => this.onUpdateSelection());
    }

    // ----------------------

    onUpdateFilterConfigsDependencies(dependencie, value) {
        const { render } = this.state;

        render.filterConfigs[dependencie] = value;
        render.exceptionConfigs[dependencie] = value;

        this.setState({
            render: render
        });
    }

    onUpdateData(layoutId, data) {
        const { render } = this.state;

        const layout = render.layouts.find(layout => layout.id === layoutId);
        if (undefined === layout) {
            return;
        }

        layout.data = undefined === data || null === data ? {} : data;

        this.setState({
            render: render
        });
    }

    onUpdateSelection(selection = undefined) {
        const { dependencies, form, transient } = this.state;

        transient.selection.layout = form.layout;
        transient.selection.frequency = form.frequency;
        transient.selection.referenceDate = new Date(form.referenceDate).getTime();
        transient.selection.documentDate = new Date(form.documentDate).getTime();

        if (undefined !== selection && undefined !== selection.id) {
            let previousDataSelection = { id: undefined };
            if (undefined !== transient.dataSelection && 0 !== transient.dataSelection.id) {
                previousDataSelection = dependencies.selection.selections
                    .find(previousDataSelection => previousDataSelection.id === transient.dataSelection.id);
            }
            const dataSelection = transient.selection.selections.find(dataSelection => dataSelection.id === selection.id);

            if (undefined !== dataSelection) {
                transient.selection.selections = transient.selection.selections
                    .filter(s => s !== dataSelection && s.id !== previousDataSelection.id && 0 !== s.id);

                if (undefined !== previousDataSelection.id && 0 !== previousDataSelection.id && dataSelection.id !== previousDataSelection.id) {
                    transient.selection.selections.push(this.mapDataSelection(previousDataSelection));
                }
            }
            else if (undefined !== previousDataSelection.id && 0 !== previousDataSelection.id) {
                transient.selection.selections = transient.selection.selections
                    .filter(s => s.id !== previousDataSelection.id);

                transient.selection.selections.push(this.mapDataSelection(previousDataSelection));
            }

            const mappedDataSelection = this.mapDataSelection(selection);

            transient.selection.dataCode = selection.dataCode;
            transient.selection.selections.push(mappedDataSelection);
            transient.dataSelection = mappedDataSelection;
        }

        this.setState({
            transient: transient
        });
    }

    onChangeValue(e, property) {
        const { form } = this.state;

        form[property] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, property, callback = undefined) {
        const { form } = this.state;

        form[property] = e;

        this.setState({
            form: form
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    onCheckValue(e, property) {
        const { form } = this.state;

        form[property] = e.target.checked;

        this.setState({
            form: form,
        });
    }

    onChangeReferenceDate(date) {
        const { form } = this.state;

        form.referenceDate = date;

        this.setState({
            form: form,
        }, () => {
            const { edition } = this.state;
            edition.update(new Date(date));
        });
    }

    onChangeDocumentDate(date) {
        const { form } = this.state;

        form.documentDate = date;

        this.setState({
            form: form,
        });
    }

    onCheckStopSchedValue(isChecked, lineId, lineOrientation) {
        const { render } = this.state;

        render.stopSchedFilter.parameters.scheduleSets = render.stopSchedFilter.parameters.scheduleSets.map(set => {
            if (lineId === set.line && lineOrientation === set.orientation) {
                set.isSelected = isChecked;
            }

            return set;
        });

        this.setState({
            render: render
        });
    }

    onSortSecheduleSets() {
        const { actions } = this.state;

        actions.isSettingOrder = true;

        this.setState({
            actions: actions
        });
    }

    onHideSchedulesSetsOrder() {
        const { actions } = this.state;

        actions.isSettingOrder = false;

        this.setState({
            actions: actions
        });
    }

    onSaveSelections() {
        const { form } = this.state;

        if (!form.saveSelection) {
            return;
        }

        const { commands, transient } = this.state;

        // Garantee that this values are saved correctly
        transient.selection.frequency = form.frequency;
        transient.selection.referenceDate = new Date(form.referenceDate).getTime();
        transient.selection.documentDate = new Date(form.documentDate).getTime();

        commands.selections.updateTml(
            transient.selection,
            (a) => this.listSuccessCallback(a, "selection", "isLoadingSelections", () => this.finalizeGetSelectionsCallback())
        );

        this.setState({
            transient: transient
        });
    }

    onRegenerateClick() {
        const { render } = this.state;

        render.filterConfigs.show = true;

        this.setState({
            render: render
        });
    }

    onSetExceptionsClick() {
        const { render } = this.state;

        render.exceptionConfigs.show = true;

        this.setState({
            render: render
        });
    }

    onAddOnClick() {
        const { render } = this.state;

        render.selectionsModal.show = true;

        this.setState({
            render: render
        });
    }

    onRegenerate(filter) {
        const { commands, actions } = this.state;

        actions.isGenerating = true;
        commands.draw.regenerateTml(
            filter,
            (a) => this.generationSuccessCallback(a),
            (a) => this.generationErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    onGenerateTmlBusSched(parameters, successCallback, errorCallback) {
        const { commands, actions } = this.state;

        actions.isGenerating = true;
        commands.draw.generateTmlBusSched(parameters, successCallback, errorCallback);

        this.setState({
            actions: actions
        });
        this.onSaveSelections();
    }

    onGenerateTmlStopSched(parameters) {
        const { render } = this.state;

        render.stopSchedFilter.show = true;
        render.stopSchedFilter.parameters = parameters;
        render.stopSchedFilter.parameters.scheduleSets = render.stopSchedFilter.parameters.scheduleSets.map(set => Object.assign({ isSelected: true }, set));

        this.setState({
            render: render
        });
    }

    onGenerateClick() {
        const { form, render } = this.state;
        const selectedLayout = render.layouts.find(layout => layout.id === form.layout);

        if (undefined === selectedLayout) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Ocorreu um erro na configuração do layout.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        if (!(Array.isArray(selectedLayout.data.scheduleSets) && selectedLayout.data.scheduleSets.some(scheduleSet => Array.isArray(scheduleSet.schedules) && 0 < scheduleSet.schedules.length))) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário adicionar pelo menos um horário.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        if (0 === selectedLayout.id && (!Array.isArray(selectedLayout.data.stops) || 0 === selectedLayout.data.stops.length)) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar pelo menos uma paragem.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        const parameters = Object.assign({
            referenceDate: form.referenceDate,
            documentDate: form.documentDate,
            frequency: form.frequency,
            hideLoopsChk: form.hideLoopsChk,
        }, selectedLayout.data);

        switch (selectedLayout.id) {
            case 0:
                this.onGenerateTmlBusSched(
                    parameters,
                    (a) => this.generationSuccessCallback(a),
                    (a) => this.generationErrorCallback(a)
                );
                break;

            case 1:
                this.onGenerateTmlStopSched(
                    parameters
                );
                break;

            default:
                // DO NOTHING
                break;
        }
    }

    onChangeDateValueFilterConfigs(date, isToUpdate) {
        if (!isToUpdate) {
            this.onChangeDocumentDate(date);
            return;
        }

        this.onChangeReferenceDate(date);
    }

    onContinueFilterConfigs(filter) {
        this.getMissingConfigs(filter);
        this.onCancelFilterConfigs();
    }

    onContinueExceptionConfigs(lines) {
        this.updateLineExceptions(lines);
        this.onCancelExceptionConfigs();
    }

    onCancelFilterConfigs() {
        const { render } = this.state;

        render.filterConfigs.show = false;

        this.setState({
            render: render
        });
    }

    onCancelExceptionConfigs() {
        const { render } = this.state;

        render.exceptionConfigs.show = false;

        this.setState({
            render: render
        });
    }

    onContinueMissingConfigs(filter) {
        this.onRegenerate(filter);
        this.onCancelMissingConfigs();
    }

    onCancelMissingConfigs() {
        const { render } = this.state;

        render.missingConfigs.show = false;
        render.missingConfigs.data = [];

        this.setState({
            render: render
        });
    }

    onConfirmStopSchedFilter() {
        const { commands, render, actions } = this.state;

        const parameters = render.stopSchedFilter.parameters;
        parameters.scheduleSets = parameters.scheduleSets.filter(set => set.isSelected);

        actions.isGenerating = true;
        commands.draw.generateTmlStopSched(
            parameters,
            (a) => this.generationSuccessCallback(a),
            (a) => this.generationErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
        this.onSaveSelections();
        this.onCancelStopSchedFilter();
    }

    onCancelStopSchedFilter() {
        const { render } = this.state;

        render.stopSchedFilter.show = false;
        render.stopSchedFilter.parameters = undefined;

        this.setState({
            render: render
        });
    }

    onCancelUpdateSelection() {
        const { render } = this.state;

        render.selectionsModal.show = false;

        this.setState({
            render: render
        });
    }

    // ----------------------

    callCallback(callback) {
        if ("function" === typeof callback) {
            callback();
        }
    }

    mapDataSelection(dataSelection) {
        if (undefined === dataSelection || null === dataSelection) {
            return undefined;
        }

        const output = Object.assign({}, dataSelection);
        output.stops = Array.isArray(dataSelection.stops) ? dataSelection.stops.slice() : [];
        output.scheduleSets = dataSelection.scheduleSets.map(set => {
            return {
                id: set.id,
                season: set.season,
                title: set.title,
                alternateText: set.alternateText,
                setOfDayTypesId: set.setOfDayTypesId,
                lineCode: set.lineCode,
                lineOrientation: set.lineOrientation,
                schedules: set.schedules.slice(),
            };
        });

        return output;
    }

    // ----------------------

    getTmlAddOn() {
        const { addOns } = this.state;

        if (!Array.isArray(addOns)) {
            return null;
        }

        const addOn = addOns.find(addOn => addOn.enabled && addOn.name === "TmlSelectionsGeneration");
        if (undefined === addOn) {
            return null;
        }

        return addOn;
    }

    renderSelectionsModal(selectionsModal) {
        const { form } = this.state;

        if (!selectionsModal.show) {
            return null;
        }

        const addOn = this.getTmlAddOn();

        if (null === addOn) {
            return null
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{addOn.label}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TmlUpdateSelectionForm
                        referenceDate={form.referenceDate}
                        onContinue={(parameters) => this.onContinueAddOn(addOn.name, addOn.label, parameters)}
                        onCancel={() => this.onCancelUpdateSelection()}
                    />
                </Modal.Body>
            </Modal>
        );
    }

    renderForm(isWaiting) {
        if (isWaiting) {
            return <LoadingSpinner />;
        }

        const { form, render } = this.state;
        return (
            <Grid className="margin-top-15" fluid>
                <FormGroup controlId="formSaveSelection">
                    <Row>
                        <Col sm={12}>
                            <Checkbox
                                className="form-checkbox pull-right"
                                defaultChecked={form.saveSelection}
                                onChange={(e) => this.onCheckValue(e, "saveSelection")}>
                                Guardar Seleções
                            </Checkbox>
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="formLayout">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Layout</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Layout selecionado"
                                noOptionsMessage={() => "Sem Layouts Configurados"}
                                onChange={(e) => this.onSelectValue(e.id, "layout")}
                                options={render.layouts}
                                isMulti={false}
                                isClearable={false}
                                isOptionSelected={function (a) {
                                    return form.layout === a.id;
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.label}
                                value={render.layouts.find(layout => layout.id === form.layout)} />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="formReferenceDate">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <DatePicker
                                id="referenceDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.referenceDate}
                                placeholder="Data de Referência"
                                onChange={(e) => this.onChangeReferenceDate(e)} />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="formDocumentDate">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Data de Documento</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <DatePicker
                                id="documentDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.documentDate}
                                placeholder="Data de Documento"
                                onChange={(e) => this.onChangeDocumentDate(e)} />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="formFrequence">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Frequência</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <FormControl type="number"
                                min="1"
                                value={form.frequency}
                                placeholder="Introduza a frequência"
                                onChange={(e) => this.onChangeValue(e, "frequency")} />
                        </Col>
                    </Row>
                </FormGroup>

                {this.renderFormAddOn()}
            </Grid>
        );
    }

    renderFormAddOn() {
        const { edition } = this.state;

        if (undefined === edition) {
            return null;
        }

        const { actions } = this.state;
        if (actions.isLoadingSchedules) {
            return (
                <LoadingSpinner />
            );
        }

        const { dependencies, form, render } = this.state;
        const isBusSchedFormVisible = 0 === form.layout;
        const isStopSchedFormVisible = 1 === form.layout;

        return (
            <React.Fragment>
                <TmlBusSchedForm isVisible={isBusSchedFormVisible}
                    edition={edition}
                    parentDependencies={dependencies}
                    isSettingOrder={actions.isSettingOrder}
                    isLoadingSetOfDayTypes={actions.isLoadingSetOfDayTypes}
                    isLoadingSchedules={actions.isLoadingSchedules}
                    isLoadingSelectionData={actions.isLoadingSelectionData}
                    getSelectionData={(a, b) => this.getSelectionData(0, a, b)}
                    onUpdateFilterConfigsDependencies={(a, b) => this.onUpdateFilterConfigsDependencies(a, b)}
                    onUpdateData={(a) => this.onUpdateData(0, a)}
                    onUpdateSelection={(a) => this.onUpdateSelection(a)}
                    onHideSchedulesSetsOrder={() => this.onHideSchedulesSetsOrder()} />

                <TmlStopSchedForm isVisible={isStopSchedFormVisible}
                    edition={edition}
                    parentDependencies={dependencies}
                    isSettingOrder={actions.isSettingOrder}
                    isLoadingSetOfDayTypes={actions.isLoadingSetOfDayTypes}
                    isLoadingSchedules={actions.isLoadingSchedules}
                    isLoadingSelectionData={actions.isLoadingSelectionData}
                    isToFilter={render.stopSchedFilter.show}
                    getSelectionData={(a, b) => this.getSelectionData(1, a, b)}
                    onUpdateData={(a) => this.onUpdateData(1, a)}
                    onUpdateSelection={(a) => this.onUpdateSelection(a)}
                    onHideSchedulesSetsOrder={() => this.onHideSchedulesSetsOrder()}
                    onCheckFilterValue={(a, b, c) => this.onCheckStopSchedValue(a, b, c)}
                    onConfirmFilter={() => this.onConfirmStopSchedFilter()}
                    onCancelFilter={() => this.onCancelStopSchedFilter()} />
            </React.Fragment>
        );
    }

    renderEditionLoadingFeedback(isLoadingEdition) {
        return (
            <HandleMessage
                title="A Carregar a Edição..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isLoadingEdition}
                small
                noButtons />
        );
    }

    renderUpdateSelectionFeedback(isExecutingAddOn) {
        const addOn = this.getTmlAddOn();

        if (null === addOn) {
            return null
        }

        return (
            <HandleMessage
                title={`A ${addOn.label}...`}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecutingAddOn}
                small
                noButtons />
        );
    }

    renderGeneratingFeedback(isGenerating) {
        return (
            <HandleMessage
                title="A Gerar..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isGenerating}
                small
                noButtons />
        );
    }

    renderUpdatingFeedback(isUpdating) {
        return (
            <HandleMessage
                title="A Atualizar Linhas..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isUpdating}
                small
                noButtons />
        );
    }

    renderIsCheckingConfigsFeedback(isCheckingConfigs) {
        return (
            <HandleMessage
                title="A Verificar Configurações..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isCheckingConfigs}
                small
                noButtons />
        );
    }

    renderFilterConfigs(form, filterConfigs) {
        if (!filterConfigs.show) {
            return null;
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Filtrar Configurações</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TmlFilterConfigs
                        referenceDate={form.referenceDate}
                        documentDate={form.documentDate}
                        lines={filterConfigs.lines}
                        onChangeDateValue={(a, b) => this.onChangeDateValueFilterConfigs(a, b)}
                        onContinue={(a) => this.onContinueFilterConfigs(a)}
                        onCancel={() => this.onCancelFilterConfigs()} />
                </Modal.Body>
            </Modal>
        );
    }

    renderSetExceptions(exceptionConfigs) {
        const { dependencies } = this.state;

        if (!exceptionConfigs.show) {
            return null;
        }
        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Configurar Excepções</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TmlExceptionConfigs
                        lines={exceptionConfigs.lines}
                        linesToRemoveExceptions={dependencies.selection.linesToRemoveExceptions}
                        onContinue={(a) => this.onContinueExceptionConfigs(a)}
                        onCancel={() => this.onCancelExceptionConfigs()} />
                </Modal.Body>
            </Modal>
        );
    }

    renderMissingConfigs(missingConfigs) {
        if (!Array.isArray(missingConfigs.data) || 0 === missingConfigs.data.length) {
            return null;
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Configurações em falta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TmlMissingConfigs
                        configs={missingConfigs.data}
                        onContinue={() => this.onContinueMissingConfigs(missingConfigs.filter)}
                        onCancel={() => this.onCancelMissingConfigs()} />
                </Modal.Body>
            </Modal>
        );
    }

    renderAddOn() {
        const addOn = this.getTmlAddOn();

        if (null === addOn) {
            return null
        }

        return (
            <Button onClick={() => this.onAddOnClick()}>{addOn.label}</Button>
        );
    }

    render() {
        const { form, render, actions, message } = this.state;

        const selectedLayout = render.layouts.find(layout => layout.id === form.layout);
        const isChangeOrderButtonDisabled = undefined === selectedLayout || undefined === selectedLayout.data.scheduleSets || (Array.isArray(selectedLayout.data.scheduleSets) && 2 > selectedLayout.data.scheduleSets.length);

        return (
            <div>
                <TitleRow title="Gerar Horário" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            {this.renderAddOn()}
                            <Button onClick={() => this.onSetExceptionsClick()}>DEFINIÇÕES</Button>
                            <Button onClick={() => this.onSortSecheduleSets()} disabled={isChangeOrderButtonDisabled}>ALTERAR ORDEM</Button>
                            <Button onClick={() => this.onRegenerateClick()}>GERAR SELEÇÕES PRÉVIAS</Button>
                            <Button onClick={() => this.onGenerateClick()}>GERAR</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                <Grid fluid>
                    {this.renderForm(actions.isLoadingSelections)}
                </Grid>

                {this.renderSelectionsModal(render.selectionsModal)}
                {this.renderFilterConfigs(form, render.filterConfigs)}
                {this.renderMissingConfigs(render.missingConfigs)}
                {this.renderSetExceptions(render.exceptionConfigs)}

                {this.renderIsCheckingConfigsFeedback(actions.isCheckingConfigs)}
                {this.renderGeneratingFeedback(actions.isGenerating)}
                {this.renderUpdatingFeedback(actions.isUpdating)}
                {this.renderEditionLoadingFeedback(actions.isLoadingEdition)}
                {this.renderUpdateSelectionFeedback(actions.isExecutingAddOn)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/tml/TmlScheduleGenerator.js